module.exports = __webpack_public_path__ + "static/BgCode-b18bb7a825cec446e2be385af560a703.png";